<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.adapters'), $t('adapters.amazon')]">
        <el-button type="success" size="mini" @click="create">+ {{ $t("text.create") }}</el-button>
      </breadcrumb>
    </div>
    <div class="table-area">
      <ul style="color: #606266">
        <li class="mgb5">北美地区授权开发者编码：721638685297</li>
        <li class="mgb5">欧洲地区授权开发者编码：5057-7414-7620</li>
        <li class="mgb5">日本授权开发者编号：0324-9076-1233</li>
      </ul>
    </div>

    <div class="red font16 center pd10">
      您的账户可用{{ foreignStores }}国外平台账户，现已加入{{
        usedForeignStores
      }}个
    </div>
    <div class="wrapper table-area">
      <vxe-table :data="items" id="recordsTable" row-id="id" ref="recordsTable" class="recordsTable" size="mini"
        resizable round auto-resize highlight-hover-row :scroll-y="{ enabled: false }">
        <vxe-table-column field="name" :title="$t('platform.name')" min-width="100">
          <template v-slot="{ row }">
            {{ row.name }}
            <div class="font10">
              {{ $t("platform.region") }}:
              <span v-if="regions.find((u) => u.value == row.region) != null">
                {{ regions.find((u) => u.value == row.region).name }}
              </span>
            </div>
            <div v-if="row.notifyUrl != null && Permit.currentTenant().id == '616'" class="font8">
              {{ $t("platform.notifyUrl") }}:{{ row.notifyUrl }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="refreshToken" :title="$t('platform.accessToken')" min-width="80">
          <template v-slot="{ row }">
            <span v-if="row.authToken == 500" class="red">
              授权异常
            </span>
            <span v-else>
              <span v-if="row.refreshToken != null">
                {{ $t("accessTokens.true") }}
              </span>
              <span v-else class="red">{{ $t("accessTokens.false") }}</span>
            </span>

          </template>
        </vxe-table-column>
        <vxe-table-column field="importOrder" :title="$t('platform.importOrder')" min-width="80">
          <template v-slot="{ row }">
            <span :class="row.importOrder == true ? 'red' : ''">
              {{ $t("boolean." + row.importOrder) }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="prefix" :title="$t('platform.prefix')" min-width="90" />
        <vxe-table-column field="shopName" :title="$t('platform.shop')" min-width="80" />
        <vxe-table-column field="storeOwnerId" :title="$t('platform.storeOwnerId')" min-width="90">
          <template v-slot="{ row }">
            <span v-if="users.find((u) => u.id == row.storeOwnerId) != null">
              {{ users.find((u) => u.id == row.storeOwnerId).name }}
            </span>
          </template>
        </vxe-table-column>

        <vxe-table-column field="mergeBargain" :title="$t('platform.mergeBargain')" min-width="102">
          <template v-slot="{ row }">
            {{ $t("boolean." + row.mergeBargain) }}
          </template>
        </vxe-table-column>

        <vxe-table-column field="percent" :title="$t('platform.percent')" min-width="102">
          <template v-slot="{ row }"> {{ row.percent }}% </template>
        </vxe-table-column>
        <!-- <vxe-table-column
          field="importTax"
          :title="$t('platform.importTax')"
          min-width="102"
        >
          <template v-slot="{ row }">
            {{ $t("boolean." + row.importTax) }}
          </template>
        </vxe-table-column> -->

        <vxe-table-column field="action" :title="$t('text.action')" width="140">
          <template v-slot="{ row }">
            <el-button type="text" size="mini" @click="authorize(row)">{{
              $t("action.authorize")
            }}</el-button>
            <el-button v-if="Permit.currentTenant().id == '616'" type="text" size="mini" @click="setNoticeUrl(row)">{{
              $t("action.setNoticeUrl") }}</el-button>
            <!-- <el-button
              type="text"
              size="mini"
              @click="subscribe(row)"
              :loading="subscribeDoing"
              >{{ $t("action.subscribe2") }}</el-button
            > -->
            <!-- 

            <el-button type="text" size="mini" @click="manualAuth(row)">{{
              $t("action.manualAuth")
            }}</el-button> -->
            <!-- <div>
              <el-button
                v-if="row.subscribeAt !== null"
                type="text"
                size="mini"
                :loading="clearSubscribeDoing"
                @click="clearSubscribe(row)"
                >{{ $t("action.clearSubscribe") }}</el-button
              >
            </div> -->
            <div>
              <el-button type="text" size="mini" @click="edit(row)">{{
                $t("text.edit")
              }}</el-button>
              <el-button type="text" size="mini" @click="deleteRow(row)"
                v-if="row.notifyUrl == null || row.notifyUrl == ''">{{
                  $t("text.delete")
                }}</el-button>
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <!-- 编辑 -->
    <el-dialog :title="$t('text.edit')" :close-on-click-modal="false" :visible.sync="editDF" width="60%">
      <el-form ref="editObjForm" :model="editObj" label-width="110px">
        <el-row>
          <el-col :span="8">
            <el-form-item :prop="'name'" :label="$t('platform.name')" :rules="[
              {
                required: true,
                validator: validateNameEdit,
                trigger: 'blur',
              },
            ]">
              <el-input size="small" v-model.trim="editObj.name" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'region'" :label="$t('platform.region')" :rules="[
              {
                required: true,
                message: $t('rules.required', [$t('platform.region')]),
                trigger: 'blur',
              },
            ]">
              <el-select size="small" v-model.trim="editObj.region" @change="selectRegion('edit')">
                <el-option v-for="region in regions" :key="region.value" :label="region.name" :value="region.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'marketplaceid'" :label="$t('tenant.country')" :rules="[
              {
                required: true,
                message: $t('rules.required', [$t('tenant.country')]),
                trigger: 'blur',
              },
            ]">
              <el-select size="small" v-model.trim="editObj.marketplaceid" filterable>
                <el-option v-for="country in countries" :key="country.marketplaceid"
                  :label="country.name + '(' + country.marketplaceid + ')'" :value="country.marketplaceid" />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item
              :prop="'sellerId'"
              :label="$t('platform.sellerId')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('platform.sellerId')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input size="small" v-model.trim="editObj.sellerId" />
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item
              :prop="'sellerId'"
              :label="$t('platform.marketplaceid')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('platform.marketplaceid')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input size="small" v-model.trim="editObj.marketplaceid" />
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <!-- <el-col :span="8">
            <el-form-item :prop="'authToken'" :label="$t('platform.authToken')">
              <el-input size="small" v-model.trim="editObj.authToken" />
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="8">
            <el-form-item :prop="'region'" :label="$t('platform.region')">
              <el-select size="small" v-model.trim="editObj.region">
                <el-option
                  v-for="region in regions"
                  :key="region.value"
                  :label="region.name"
                  :value="region.value"
                />
              </el-select>
            </el-form-item>
          </el-col> -->

          <el-col :span="8">
            <el-form-item :prop="'prefix'" :label="$t('platform.prefix')">
              <el-input size="small" v-model.trim="editObj.prefix" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'storeOwnerId'" :label="$t('platform.storeOwnerId')" :rules="[
              {
                required: true,
                message: $t('rules.required', [$t('platform.storeOwnerId')]),
                trigger: 'blur',
              },
            ]">
              <el-select size="small" v-model.trim="editObj.storeOwnerId">
                <el-option v-for="user in users" :key="user.id" :label="user.name" :value="user.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'shopId'" :label="$t('platform.shop')" :rules="[
              {
                required: true,
                message: $t('rules.required', [$t('platform.shop')]),
                trigger: 'blur',
              },
            ]">
              <el-select size="small" v-model.trim="editObj.shopId">
                <el-option v-for="shop in shops" :key="shop.id" :label="shop.name" :value="shop.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item :prop="'importOrder'" :label="$t('platform.importOrder')">
              <el-checkbox size="small" v-model.trim="editObj.importOrder" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'mergeBargain'" :label="$t('platform.mergeBargain')">
              <el-checkbox size="small" v-model.trim="editObj.mergeBargain" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'percent'" :label="$t('platform.percent')">
              <el-input size="small" v-model.trim="editObj.percent" />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="8">
            <el-form-item
              :prop="'importOrder'"
              :label="$t('platform.importTax')"
            >
              <el-checkbox size="small" v-model.trim="editObj.importTax" />
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" plain :loading="editDoing" size="small" @click="editSubmit">{{ $t("text.submit")
          }}</el-button>
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog :title="$t('text.create')" :close-on-click-modal="false" :visible.sync="addDF" width="60%">
      <el-form ref="addObjForm" :model="addObj" label-width="110px">
        <el-row>
          <el-col :span="8">
            <el-form-item :prop="'name'" :label="$t('platform.name')" :rules="[
              { required: true, validator: validateName, trigger: 'blur' },
            ]">
              <el-input size="small" v-model.trim="addObj.name" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'region'" :label="$t('platform.region')" :rules="[
              {
                required: true,
                message: $t('rules.required', [$t('platform.region')]),
                trigger: 'blur',
              },
            ]">
              <el-select size="small" v-model.trim="addObj.region" @change="selectRegion('add')">
                <el-option v-for="region in regions" :key="region.value" :label="region.name" :value="region.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'marketplaceid'" :label="$t('tenant.country')" :rules="[
              {
                required: true,
                message: $t('rules.required', [$t('tenant.country')]),
                trigger: 'blur',
              },
            ]">
              <el-select size="small" v-model.trim="addObj.marketplaceid" filterable>
                <el-option v-for="country in countries" :key="country.marketplaceid"
                  :label="country.name + '(' + country.marketplaceid + ')'" :value="country.marketplaceid" />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item
              :prop="'sellerId'"
              :label="$t('platform.sellerId')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('platform.sellerId')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input size="small" v-model.trim="addObj.sellerId" />
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="8">
            <el-form-item
              :prop="'marketplaceid'"
              :label="$t('platform.marketplaceid')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('platform.marketplaceid')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input size="small" v-model.trim="addObj.marketplaceid" />
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <!-- <el-col :span="8">
            <el-form-item :prop="'authToken'" :label="$t('platform.authToken')">
              <el-input size="small" v-model.trim="addObj.authToken" />
            </el-form-item>
          </el-col> -->

          <el-col :span="8">
            <el-form-item :prop="'prefix'" :label="$t('platform.prefix')">
              <el-input size="small" v-model.trim="addObj.prefix" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'storeOwnerId'" :label="$t('platform.storeOwnerId')" :rules="[
              {
                required: true,
                message: $t('rules.required', [$t('platform.storeOwnerId')]),
                trigger: 'blur',
              },
            ]">
              <el-select size="small" v-model.trim="addObj.storeOwnerId">
                <el-option v-for="user in users" :key="user.id" :label="user.name" :value="user.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'shopId'" :label="$t('platform.shop')" :rules="[
              {
                required: true,
                message: $t('rules.required', [$t('platform.shop')]),
                trigger: 'blur',
              },
            ]">
              <el-select size="small" v-model.trim="addObj.shopId">
                <el-option v-for="shop in shops" :key="shop.id" :label="shop.name" :value="shop.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item :prop="'mergeBargain'" :label="$t('platform.mergeBargain')">
              <el-checkbox size="small" v-model.trim="addObj.mergeBargain" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'importOrder'" :label="$t('platform.importOrder')">
              <el-checkbox size="small" v-model.trim="addObj.importOrder" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'percent'" :label="$t('platform.percent')">
              <el-input size="small" v-model.trim="addObj.percent" />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="8">
            <el-form-item
              :prop="'importOrder'"
              :label="$t('platform.importTax')"
            >
              <el-checkbox size="small" v-model.trim="addObj.importTax" />
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" plain :loading="saveDoing" size="small" @click="addSubmit">{{ $t("text.submit")
          }}</el-button>
        <el-button size="small" @click="addDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 手动授权 -->
    <el-dialog :title="$t('action.manualAuth')" :close-on-click-modal="false" :visible.sync="manualAuthDF" width="30%">
      <el-form ref="manualAuthObjForm" :model="manualAuthObj" label-width="80px">
        <el-form-item :prop="'sellerId'" :label="$t('platform.sellerId')" :rules="[
          {
            required: true,
            message: $t('rules.required', [$t('platform.sellerId')]),
            trigger: 'blur',
          },
        ]">
          <el-input size="small" v-model.trim="manualAuthObj.sellerId" />
        </el-form-item>
        <el-form-item :prop="'authToken'" :label="$t('platform.authToken')" :rules="[
          {
            required: true,
            message: $t('rules.required', [$t('platform.sellerId')]),
            trigger: 'blur',
          },
        ]">
          <el-input size="small" v-model.trim="manualAuthObj.authToken" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" plain :loading="manualAuthDoing" size="small" @click="manualAuthSubmit">{{
          $t("text.submit") }}</el-button>
        <el-button size="small" @click="manualAuthDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!--setNoticeUrl  -->
    <el-dialog :title="$t('action.setNoticeUrl')" :close-on-click-modal="false" :visible.sync="setNoticeUrlDF"
      width="30%">
      <el-form ref="setNoticeUrlObjForm" :model="setNoticeUrlObj" label-width="60px">
        <el-form-item :prop="'notifyUrl'" :label="$t('platform.notifyUrl')" :rules="[
          {
            required: true,
            message: $t('rules.required', [$t('platform.notifyUrl')]),
            trigger: 'blur',
          },
        ]">
          <el-input size="small" v-model.trim="setNoticeUrlObj.notifyUrl" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" plain :loading="setNoticeUrlDoing" size="small" @click="setNoticeUrlSubmit">{{
          $t("text.submit") }}</el-button>
        <el-button size="small" @click="setNoticeUrlDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import Cookies from "@/utils/cookies";
import { page } from "@/utils/mixins.js";
import AmazonStore from "@/api/adapterAmazonStore";
import Tenant from "@/api/tenant";
import User from "@/api/user";
import Shop from "@/api/shop";

export default {
  mixins: [page],
  components: {},
  data() {
    var validateName = (rule, value, callback) => {
      if (value === null || value === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("platform.name")]))
        );
        return;
      }
      const names = this.items.map((i) => i.name);
      if (names.includes(value)) {
        callback(new Error(this.$t("rules.exist", [this.$t("platform.name")])));
      } else {
        callback();
      }
    };
    var validateNameEdit = (rule, value, callback) => {
      if (value === null || value === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("platform.name")]))
        );
        return;
      }
      const names = this.items.map((i) => i.name);
      if (names.includes(value) && this.row.name !== value) {
        callback(new Error(this.$t("rules.exist", [this.$t("platform.name")])));
      } else {
        callback();
      }
    };
    return {
      items: [],
      users: [],
      shops: [],
      tenant: null,
      foreignStores: 0,
      usedForeignStores: 0,
      // regions: [
      //   { value: "NA", name: "北美地区(美国，加拿大)" },
      //   { value: "EU", name: "欧洲地区(德国,法国,英国,西班牙,意大利,印度)" },
      //   { value: "JP", name: "日本" },
      // ],
      regions: [
        {
          value: "NA",
          name: "北美地区",
          items: [
            {
              value: "CA",
              name: "加拿大",
              marketplaceid: "A2EUQ1WTGCTBG2",
            },
            {
              value: "US",
              name: "美国",
              marketplaceid: "ATVPDKIKX0DER",
            },

            {
              value: "MX",
              name: "墨西哥",
              marketplaceid: "A1AM78C64UM0Y8",
            },
            {
              value: "BR",
              name: "巴西",
              marketplaceid: "A2Q3Y263D00KWC",
            },
          ],
        },
        {
          value: "EU",
          name: "欧洲地区",
          items: [
            {
              value: "ES",
              name: "西班牙",
              marketplaceid: "A1RKKUPIHCS9HS",
            },
            {
              value: "GB",
              name: "英国",
              marketplaceid: "A1F83G8C2ARO7P",
            },
            {
              value: "FR",
              name: "法国",
              marketplaceid: "A13V1IB3VIYZZH",
            },
            {
              value: "NL",
              name: "荷兰",
              marketplaceid: "A1805IZSGTT6HS",
            },
            {
              value: "DE",
              name: "德国",
              marketplaceid: "A1PA6795UKMFR9",
            },
            {
              value: "IT",
              name: "意大利",
              marketplaceid: "APJ6JRA9NG5V4",
            },
            {
              value: "TR",
              name: "土耳其",
              marketplaceid: "A33AVAJ2PDY3EV",
            },
            {
              value: "AE",
              name: "阿拉伯联合酋长国",
              marketplaceid: "A2VIGQ35RCS4UG",
            },
            {
              value: "IN",
              name: "印度",
              marketplaceid: "A21TJRUUN4KGV",
            },
            {
              value: "BE",
              name: "比利时",
              marketplaceid: "AMEN7PMS3EDWL",
            },
            {
              value: "SE",
              name: "瑞典",
              marketplaceid: "A2NODRKZP88ZB9",
            },
            {
              value: "PL",
              name: "波兰",
              marketplaceid: "A1C3SOZRARQ6R3",
            },
            {
              value: "EG",
              name: "埃及",
              marketplaceid: "ARBP9OOSHTCHU",
            },
            {
              value: "SA",
              name: "沙特阿拉伯",
              marketplaceid: "A17E79C6D8DWNP",
            },
          ],
        },
        {
          value: "JP",
          name: "远东",
          items: [
            {
              value: "SG",
              name: "新加坡",
              marketplaceid: "A19VAU5U5O7RUS",
            },
            {
              value: "AU",
              name: "澳大利亚",
              marketplaceid: "A39IBJ37TRP1C6",
            },
            {
              value: "JP",
              name: "日本",
              marketplaceid: "A1VC38T7YXB528",
            },
          ],
        },
      ],
      // 新增
      addDF: false,
      validateName: validateName,
      addObj: {
        name: null,
        // sellerId: null,
        marketplaceid: null,
        authToken: null,
        region: null,
        prefix: null,
        storeOwnerId: null,
        importOrder: null,
        shopId: null,
        shopName: null,
        percent: 0,
        mergeBargain: false,
        importTax: true,
      },
      saveDoing: false,
      adminDF: false,
      countries: [],
      // 编辑
      validateNameEdit: validateNameEdit,
      editDF: false,
      row: null,
      editObj: {
        name: null,
        sellerId: null,
        marketplaceid: null,
        authToken: null,
        region: null,
        prefix: null,
        storeOwnerId: null,
        importOrder: null,
        shopId: null,
        shopName: null,
        percent: 0,
        mergeBargain: false,
        importTax: null,
      },
      editDoing: false,
      //
      subscribeDoing: false,
      clearSubscribeDoing: false,
      //
      manualAuthObj: {
        sellerId: null,
        authToken: null,
      },
      manualAuthDoing: false,
      manualAuthDF: false,
      //
      setNoticeUrlDF: false,
      setNoticeUrlObj: {
        notifyUrl: null,
      },
      setNoticeUrlDoing: false,
    };
  },

  created() {
    const self = this;
    self.loadData();
    axios
      .all([
        User.findByTenantId(self.Permit.currentTenant().id),
        Shop.findByTenantId(),
      ])
      .then(
        axios.spread(function (users, shops) {
          if (users.status === 200) {
            self.users = users.data.filter((r) => r.voidAt == null);
          } else {
            self.sysError();
          }
          if (shops.status === 200) {
            self.shops = shops.data;
          } else {
            self.sysError();
          }
        })
      );
  },
  methods: {
    setNoticeUrl(row) {
      const self = this;
      self.row = row;
      self.setNoticeUrlObj.notifyUrl = row.notifyUrl;
      self.setNoticeUrlDF = true;
    },
    setNoticeUrlSubmit() {
      const self = this;
      this.$refs.setNoticeUrlObjForm.validate((valid) => {
        if (valid) {
          self.setNoticeUrlDoing = true;
          AmazonStore.updateNoticeUrl(self.row.id, self.setNoticeUrlObj).then(
            function (res) {
              self.setNoticeUrlDoing = false;
              self.setNoticeUrlDF = false;
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.setNoticeUrlSuccess"),
                  type: "success",
                });
                self.loadData();
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    manualAuth(row) {
      const self = this;
      self.row = row;
      self.manualAuthObj.sellerId = row.sellerId;
      self.manualAuthObj.authToken = row.authToken;
      self.manualAuthDoing = false;
      self.manualAuthDF = true;
    },
    manualAuthSubmit() {
      const self = this;
      this.$refs.manualAuthObjForm.validate((valid) => {
        if (valid) {
          self.manualAuthDoing = true;
          AmazonStore.manualAuth(self.row.id, self.manualAuthObj).then(
            function (res) {
              self.manualAuthDoing = false;
              self.manualAuthDF = false;
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.manualAuthSuccess"),
                  type: "success",
                });
                self.loadData();
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    // 授权
    authorize(row) {
      Cookies.setAmazonRowId(row.id);
      AmazonStore.getOauthUri(row.id).then(function (res) {
        if (res.data.code == 200) {
          window.open(res.data.entity);
        } else {
          self.sysError();
        }
      });
    },
    //订阅
    subscribe(row) {
      const self = this;
      self.subscribeDoing = true;
      AmazonStore.subscribe(row.id).then(function (res) {
        self.subscribeDoing = false;
        if (res.status === 200) {
          self.sysResult(res.data);
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    clearSubscribe(row) {
      const self = this;
      self.clearSubscribeDoing = false;
      AmazonStore.clearSubscribe(row.id).then(function (res) {
        self.clearSubscribeDoing = false;
        if (res.status === 200) {
          self.sysResult(res.data);
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    //
    selectRegion(type) {
      const self = this;
      self.countries = [];
      if (type == "add") {
        self.addObj.marketplaceid = null;
        if (self.addObj.region != null && self.addObj.region != null) {
          self.countries = self.regions.find(
            (r) => r.value == self.addObj.region
          ).items;
        }
      }
      if (type == "edit") {
        self.editObj.marketplaceid = null;
        if (self.editObj.region != null && self.editObj.region != null) {
          self.countries = self.regions.find(
            (r) => r.value == self.editObj.region
          ).items;
        }
      }
    },
    // 新增
    create() {
      const self = this;
      if (self.usedForeignStores >= self.foreignStores) {
        self.$message({
          message: "国外平台数量已达上限，请去联系客服购买",
          type: "warning",
        });
        return;
      }
      self.addObj.name = null;
      // self.addObj.sellerId = null;
      self.addObj.authToken = null;
      self.addObj.region = self.regions[0].value;
      self.selectRegion("add");
      self.addObj.marketplaceid = null;
      self.addObj.prefix = null;
      self.addObj.storeOwnerId = null;
      self.addObj.importOrder = false;
      self.addObj.shopId = null;
      self.addObj.shopName = null;
      self.addObj.mergeBargain = false;
      self.addObj.importTax = true;
      self.addDF = true;
    },
    addSubmit() {
      const self = this;
      this.$refs.addObjForm.validate((valid) => {
        if (valid) {
          if (self.addObj.prefix === "") {
            self.addObj.prefix = null;
          }
          self.addObj.shopName = self.shops.find(
            (s) => s.id === self.addObj.shopId
          ).name;
          self.saveDoing = true;
          AmazonStore.create(self.addObj).then(function (res) {
            self.saveDoing = false;
            self.addDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.usedForeignStores = self.usedForeignStores + 1;
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        AmazonStore.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.usedForeignStores = self.usedForeignStores - 1;
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑
    edit(row) {
      const self = this;
      self.row = row;
      self.editObj.name = row.name;
      // self.editObj.sellerId = row.sellerId;
      self.editObj.region = row.region;
      self.selectRegion("edit");
      self.editObj.marketplaceid = row.marketplaceid;
      self.editObj.authToken = row.authToken;
      self.editObj.prefix = row.prefix;
      self.editObj.importOrder = row.importOrder;
      self.editObj.shopId = row.shopId;
      self.editObj.shopName = row.shopName;
      self.editObj.percent = row.percent;
      self.editObj.mergeBargain = row.mergeBargain;
      self.editObj.importTax = row.importTax;
      const selectedUser = self.users.find((u) => u.id === row.storeOwnerId);
      if (selectedUser != null) {
        self.editObj.storeOwnerId = row.storeOwnerId;
      }
      self.editDF = true;
    },
    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          if (self.editObj.prefix == "") {
            self.editObj.prefix = null;
          }
          self.editObj.shopName = self.shops.find(
            (s) => s.id === self.editObj.shopId
          ).name;
          self.editDoing = true;
          AmazonStore.update(self.row.id, self.editObj).then(function (res) {
            self.editDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    loadData() {
      const self = this;
      self.loadingStart();
      axios
        .all([
          AmazonStore.findByTenantId(),
          Tenant.findById(self.Permit.currentTenant().id),
        ])
        .then(
          axios.spread(function (stores, tenant) {
            self.loadingEnd();
            if (stores.status === 200) {
              self.items = stores.data;
            } else {
              self.sysError();
            }
            if (tenant.data.code === 200) {
              self.tenant = tenant.data.entity;
              self.foreignStores = self.tenant.charge.foreignStores;
              self.usedForeignStores = self.tenant.charge.usedForeignStores;
            } else {
              self.sysError();
            }
          })
        );
    },
  },
};
</script>
